import d3 from 'd3';
import { Signal } from 'signals';

export default class Facet {

  constructor(apiURL, config) {
    this._groups = [];
    this._apiURL = apiURL;
    this._metadataPath = config.metadataPath;
    this._name = config.name;
    this._fkey = config.fkey;
    this._label = config.label;
    this._removeEmpty = config.removeEmpty;
    this._queryParams = config.queryParams;

    this.dataChanged = new Signal();
    this.selectionChanged = new Signal();
  }

  get idKey() { return this._fkey; }
  get labelKey() { return this._label; }
  get valueKey() { return 'value'; }
  get total() { return this._joined.reduce((memo, v, k) => {
    return memo + parseInt(v[this.valueKey])
  }, 0) }

  loadMetadata() {
    console.info(`loading ${this._name} metadata`);
    return this._loadCSV(this._apiURL + this._metadataPath)
      .then(
        data => {
          console.info(`${this._name} metadata loaded`);
          this._metadata = data;
          return this;
        },
        error => {
          console.warn(`${this._name} metadata error`);
          throw error;
        }
      );
  }

  join(data) {
    const values = data[this._fkey];
    this._joined = this._metadata.map(metadataObj => {
      const id = metadataObj[this._fkey];
      const val = values[id] || 0;
      return Object.assign({ [this.valueKey]: val }, metadataObj);
    });
    if (this._removeEmpty)
      this._joined = this._joined.filter(item => item[this.valueKey]);
    this.dataChanged.dispatch();
  }

  groups(limit) {
    if (limit) return this._joined.slice(0, limit);
    return this._joined;
  }

  clear() {
    this._extent = null;
    this.selectionChanged.dispatch(this._extent);
  }

  // get max() {
  //   return this._dimensionFunction(this._dimension.top(1)[0]);
  // }

  // get min() {
  //   return this._dimensionFunction(this._dimension.bottom(1)[0]);
  // }

  // HANDLERS


  // HELPERS

  _loadCSV(path) {
    return new Promise((resolve, reject) => {
      const req = d3.csv(path);

      req.get((error, data) => {
        if (error) {
          reject(Error(error));
        } else {
          resolve(data);
        }
      });
    });
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/models/facets/Facet.es6
 **/